/**
 * @file src/core/ScrollToTop.jsx
 *
 * ⬆️ A NEW PAGE OPENS AT ITS TOP.
 *
 * Nothing reset the scroll on navigation, so a footer link opened the next
 * page at the same depth — at its bottom, beside another footer. React Router
 * keeps the scroll position across routes; a full page load had the browser
 * restore it too.
 *
 * Two things scroll here: the window (public pages, GuestLayout) and the
 * workspace's `#main-content` panel (AppShell, overflow-y-auto). Both go to 0.
 * A link to a `#section` is left alone — that is a jump the person asked for.
 */
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  try { window.history.scrollRestoration = 'manual'; } catch { /* some embedded browsers refuse */ }
}

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    document.getElementById('main-content')?.scrollTo?.(0, 0);
  }, [pathname, search, hash]);

  return null;
}
